import { DeviationDto, CourierInvoiceDisputeDto, InvoiceSummaryDto } from 'src/generated/services/TFinancialApi';
import { IRangeValue } from 'src/presentations/components/molecules/fields/rhf-mui-fields';
import { QuestionnaireTheme } from '../../forms/Questionnaire';

export interface IDisputeCourierProps {
  invoiceSummary: InvoiceSummaryDto;
  invoiceDispute: CourierInvoiceDisputeDto;
  open: boolean;
  onClose: () => void;
}

export interface IDisputeCourierFormValues {
  agreementType:
    | 'ACCEPT_INVOICE_AS_IS'
    | 'AMEND_INVOICE_CREDIT_NOTE'
    | 'REJECT_INVOICE'
    | 'COMMERCIAL_SETTLEMENT_CREDIT_NOTE'
    | 'ACCEPT_INVOICE_WITH_CREDIT_NOTE';
  reason: string;
  expectedAmount?: 'BREAK_DOWN_PER_DEVIATION' | 'LUMP_SUM';
  amountOption?: 'FULL_INVOICE' | 'DEVIATIONS' | 'OTHER';
  otherAmount?: string; // User input for "Other amount" option
  totalAmount?: string; // Calculated field for payload (not visible to user)
  disputeTableItems: IDisputeTableItem[];
}

export interface IDisputeFormValues {
  agreementType:
    | 'ACCEPT_INVOICE_AS_IS'
    | 'AMEND_INVOICE_CREDIT_NOTE'
    | 'REJECT_INVOICE'
    | 'COMMERCIAL_SETTLEMENT_CREDIT_NOTE'
    | 'ACCEPT_INVOICE_WITH_CREDIT_NOTE'
    | 'ACCEPT_INVOICE'
    | 'CANCEL_DISPUTE'
    | null;
  reason?: string;
  expectedAmount?: 'BREAK_DOWN_PER_DEVIATION' | 'LUMP_SUM';
  amountOption?: 'FULL_INVOICE' | 'DEVIATIONS' | 'OTHER';
  otherAmount?: string; // User input for "Other amount" option
  totalAmount?: string; // Calculated field for payload (not visible to user)
  disputeTableItems: IInvoiceIssueData[];
}

export enum OneOffOrRecurring {
  OneOff = 'ONE_OFF',
  Recurring = 'RECURRING',
}

export interface IDisputeTableItem {
  id: number;
  deviationId: string;
  chargeName: string;
  deviationAmount: string;
  expectedAmount: number;
  validityPeriod: IRangeValue;
  currencyType: string;
  oneOffOrRecurring: 'ONE_OFF' | 'RECURRING';
  status: DeviationDto['status'];
}

export interface IInvoiceIssueData {
  no: number;
  key: string;
  category: string;
  quantity: number;
  shipmentsImpacted: string;
  totalAmount: number;
  currency: string;
}

export interface ApprovalDecisionProps {
  invoiceSummary: InvoiceSummaryDto;
  title?: string;
  questionnaireTheme?: QuestionnaireTheme;
  isEditable?: boolean;
}

export enum DisputeStep {
  Step1_ContactServiceProvider = 0,
  Step2_Resolution = 1,
  Step3_Summary = 2,
}
